import {
  GridColDef,
  GridInitialState,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import React from "react";
import { Link } from "react-router-dom";
import {
  getDateValue,
  renderDateCell,
  renderHumanReadableDateCell,
  renderNumberCell,
  renderWrappedCell,
  serverFilterDateOperators,
  serverFilterStringOperators,
  topListedOperator,
} from "utils/dataGrid";
import GaneshDataGridServerProcessing from "../../DataGrid/GaneshDataGridServerProcessing";

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [{ field: "brand_name", sort: "asc" }] },
  pagination: { paginationModel: { pageSize: 250, page: 0 } },
  pinnedColumns: { left: ["brand_id", "brand_name"] },
  columns: { columnVisibilityModel: {} },
  density: "standard",
};

const columns_def: GridColDef[] = [
  {
    field: "brand_id",
    headerName: "Brand ID",
    description: "The unique numeric identifier associated with the brand.",
    type: "string",
    width: 150,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: true,
  },
  {
    field: "brand_name",
    headerName: "Brand Name",
    description: "The common name by which the brand is known.",
    width: 200,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: true,
    renderCell: (params: GridRenderCellParams) => (
      <Link to={`/data-ops/brand/${params.row.brand_id}`}>{params.value}</Link>
    ),
  },
  {
    field: "chain_id",
    headerName: "Chain ID",
    description:
      "A unique, lowercase identifier for a chain in the dataplor database.",
    type: "string",
    width: 200,
    filterable: true,
    filterOperators: serverFilterStringOperators,
  },
  {
    field: "total_poi_count_filtered",
    headerName: "Active Count",
    description:
      "The number of active places associated with this brand, excluding ignored places and duplicates.",
    type: "number",
    width: 125,
    renderCell: renderNumberCell,
    filterable: false,
    sortable: true,
  },
  {
    field: "omni_count",
    headerName: "Omni Count",
    description: "The count of distinct omnis associated with this brand. ",
    type: "number",
    width: 100,
    renderCell: renderNumberCell,
    filterable: false,
    sortable: true,
  },
  {
    field: "country_count",
    headerName: "Country Count",
    description:
      "The count of distinct countries where places associated with this brand are located in the dataplor database. This reflects the actual data in our database, not the expected regions where the brand operates.",
    type: "number",
    width: 100,
    renderCell: renderNumberCell,
    filterable: false,
    sortable: true,
  },

  {
    field: "country_codes",
    headerName: "Country Codes",
    description:
      "The list of distinct country codes for places associated with the brand in our database. This reflects the actual data in our database, not the expected regions where the brand operates.",
    width: 300,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: false,
    renderCell: renderWrappedCell,
  },
  {
    field: "frozen_at",
    headerName: "Frozen At",
    description:
      "The date the brand was marked as frozen, indicating that it has been approved, and no further changes can be made except for updates related to Omniscraper or manual observations.",
    type: "date",
    width: 150,
    valueGetter: getDateValue,
    renderCell: renderHumanReadableDateCell,
    filterable: true,
    filterOperators: serverFilterDateOperators,
  },
  {
    field: "top_listed_classification",
    headerName: "Classification",
    description:
      "Strategic lists or categories to which this brand belongs. Use for filtering to see a specific list of brands.",
    width: 200,
    filterable: true,
    filterOperators: topListedOperator,
    sortable: false,
  },
  {
    field: "query_last_executed",
    headerName: "Data Last Updated",
    description:
      "The date when the data for this brand was last retrieved and aggregated from the database.",
    type: "date",
    width: 200,
    valueGetter: getDateValue,
    renderCell: renderDateCell,
    filterable: false,
    sortable: false,
  },
];

const BrandsSummaryTable: React.FC<any> = () => {
  return (
    <GaneshDataGridServerProcessing
      fetchApi="/brand_reports/brands_summary"
      columns={columns_def}
      gridId="brandsSummaryGrid"
      defaultGridState={defaultGridState}
    />
  );
};
export default BrandsSummaryTable;
